import { render, staticRenderFns } from "./Messagerie.vue?vue&type=template&id=f5f6e778&scoped=true&"
import script from "./Messagerie.vue?vue&type=script&lang=ts&"
export * from "./Messagerie.vue?vue&type=script&lang=ts&"
import style0 from "./Messagerie.vue?vue&type=style&index=0&id=f5f6e778&lang=scss&scoped=true&"
import style1 from "./Messagerie.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f6e778",
  null
  
)

export default component.exports